export class EditFieldTypeConst {
  public static TEXT_FIELD = "text";
  public static DROPDOWN_FIELD = "dropdown";
  public static DATE_FIELD = "date";
  public static NUMBER_FIELD = "number";
  public static TIME_FIELD = "time";
}
